<template>
    <div class="view view__lms__user_account_logactivity">
        <lms-user-account-activity-log/>
    </div>
</template>

<script>
import LmsUserAccountActivityLog
  from '@/components/lms/user/account/LmsUserAccountActivityLog'

export default {
  components: { LmsUserAccountActivityLog },
  name: 'view-lms-user-account-activity-log',
  computed: {
    tokenUserId () {
      return this.$store.getters.getAuthUserFirstStageTokenDataID || this.$store.getters.getAuthUserSecondStageTokenDataUserId
    },
    userId () {
      return this.$store.getters.getLmsUserAccountId
    }
  },
  watch: {
    userId: function () {
      if (this.userId !== '') {
        this.$eventBus.$emit('stop-loading')
      }
    }
  },
  methods: {
    getUser () {
      this.$eventBus.$emit('start-loading')
      this.$store.dispatch('lmsUserAccountGet', this.tokenUserId)
    },
    clearUser () {
      this.$store.dispatch('lmsUserAccountClear')
    }
  },
  created () {
    this.getUser()
  },
  beforeDestroy () {
    this.clearUser()
  }
}
</script>
